import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  dropDownData: [],
  dropDownLoader: false,
  DataList: [],
  DataLoader: true,
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_GET_APPLICATION_LIST:
      return {
        ...state,
        dropDownData: [],
        dropDownLoader: false,
      }
    case types.FAILED_GET_APPLICATION_LIST:
      return {
        ...state,
        dropDownData: [],
        dropDownLoader: false,
      }
    case types.SUCCESS_GET_RESTIRICTED_APP:
      return {
        ...state,
        DataList: action.data,
        DataLoader: false,
      }
    case types.FAILED_GET_RESTIRICTED_APP:
      return {
        ...state,
        DataList: [],
        DataLoader: false,
      }
    case types.LOADER_RESTIRICTED_APP: {
      return {
        ...state,
        DataLoader: true,
      }
    }
    default:
      return state
  }
}
export default reducer